<div class="page">
    <div class="title-btn-container">
      <div class="title">{{ 'store.ecommerceOrders.title' | translate }}</div>
    </div>
    <div class="vouchers-filters-container">
      <div class="inputs-container">
        <div class="search-container">
          <img src="assets/images/search.svg">
          <input
            [(ngModel)]="params.search"
            (keyup.enter)="doSearchByEnter($event);"
            (keyup)="doSearchByKeyUp($event);"
            [placeholder]="'store.ecommerceOrders.searchPlaceholder' | translate" type="text">
        </div>
      </div>
      <div class="totals-container">
        <div class="totals-stats">
          <div class="value">{{totalOrders}}</div>
          <div class="label">{{ 'store.ecommerceOrders.totalOrders' | translate }}</div>
        </div>
        <div class="totals-stats">
          <div class="value">{{totalOrderBalance}}</div>
          <div class="label">{{ 'store.ecommerceOrders.totalBalance' | translate }}</div>
        </div>
      </div>

    </div>
    <div class="mobile-only mobile-table" *ngIf="dataList?.length">
      <div class="mobile-table__card" *ngFor="let item of dataList; let i = index">
        <div class="mobile-table__header">
          <div>
            <div class="mobile-table__title">{{ 'store.ecommerceOrders.orderNumberShort' | translate: { number: item.orderNumber } }}</div>
            <div  class="mobile-table__meta"><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y' }}</span></div>
          </div>
          <div class="mobile-table__actions">
            <button
              class="mobile-table__action-btn"
              [placement]="'bottom'"
              [outsideClick]="true"
              [popover]="popTemplateMobile"
              [attr.aria-label]="'common.actions' | translate"
            >
              <i class="fa fa-ellipsis-h" aria-hidden="true"></i>
            </button>
            <ng-template #popTemplateMobile>
              <div class="mobile-table__menu-item" (click)="goToDetails(item.id)">{{ 'common.viewDetails' | translate }}</div>
            </ng-template>
          </div>
        </div>
        <div class="mobile-table__rows">
          <div class="mobile-table__row">
            <div class="mobile-table__label">{{ 'store.ecommerceOrders.table.totalAmount' | translate }}</div>
            <div class="mobile-table__value">{{item.totalAmount}}</div>
          </div>
          <div class="mobile-table__row">
            <div class="mobile-table__label">{{ 'common.status' | translate }}</div>
            <div class="mobile-table__value">
              <div style="color:  white; " [style.background-color]="orderStatusColor[item.status]"> {{item.status}}</div>
            </div>
          </div>
          <div class="mobile-table__row">
            <div class="mobile-table__label">{{ 'store.ecommerceOrders.table.userName' | translate }}</div>
            <div class="mobile-table__value">{{item.user?.firstName}} {{item.user?.lastName}}</div>
          </div>
          <div class="mobile-table__row">
            <div class="mobile-table__label">{{ 'store.products.table.updatedDate' | translate }}</div>
            <div  class="mobile-table__value"><span class="ltr-text">{{item.updatedDate | date: 'hh:mm, d MMMM y' }}</span></div>
          </div>
        </div>
      </div>
    </div>
    <div class="empty-list mobile-only" *ngIf="!dataList?.length">{{ 'store.ecommerceOrders.empty' | translate }}</div>
    <div class="table-wrapper desktop-only">
      <table class="table AgentsTable">
        <thead>
        <tr>
          <th>{{ 'store.ecommerceOrders.table.orderNumber' | translate }}</th>
          <th>{{ 'store.ecommerceOrders.table.totalAmount' | translate }}</th>
          <th>{{ 'common.status' | translate }}</th>
          <th>{{ 'store.ecommerceOrders.table.userName' | translate }}</th>
          <th>{{ 'store.products.table.createdDate' | translate }}</th>
          <th>{{ 'store.products.table.updatedDate' | translate }}</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let item of dataList; let i = index">
          <td>{{item.orderNumber}}</td>
          <td>{{item.totalAmount}}</td>

          <td>
            <div style="color:  white; " [style.background-color]="orderStatusColor[item.status]"> {{item.status}}</div>
          </td>

          <td>{{item.user?.firstName}} {{item.user?.lastName}}</td>
          <td ><span class="ltr-text">{{item.createdDate | date: 'hh:mm, d MMMM y' }}</span></td>
          <td ><span class="ltr-text">{{item.updatedDate | date: 'hh:mm, d MMMM y' }}</span></td>
          <td class="dots-container">
            <button
              [placement]="'left'"
              [outsideClick]="true"
              [popover]="popTemplate"
            >
              <i
                class="fa fa-ellipsis-h" aria-hidden="true"></i>
            </button>

            <ng-template #popTemplate>
              <div class="mobile-table__menu-item" (click)="goToDetails(item.id)"> {{ 'common.viewDetails' | translate }}
              </div>
            </ng-template>
          </td>
        </tr>
        </tbody>

      </table>
      <div class="empty-list" *ngIf="!dataList?.length">{{ 'store.ecommerceOrders.empty' | translate }}</div>

    </div>
    <div class="table-footer">
      <app-pagination [totalPages]="totalPages" [currentPage]="params?.page" (backClicked)="backClick($event)"
                      (nextClicked)="nextClick($event)"></app-pagination>
      <!-- <app-export-csv [disabled]="!dataList?.length" path="web/vouchers/csv" [params]="params"></app-export-csv> -->
    </div>
    <ngx-spinner color="rgba(30, 205, 100, 1)" type="ball-scale-multiple"></ngx-spinner>
  </div>
